import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { isPublisher, isReadOnly } from '~/helpers'
import { useAppSelector } from '~/store/hooks'

import { useCampaignReadOnly } from './useCampaignReadOnly'

/**
 * Mesma checagem de editabilidade usada por GenericEditCost (ver Generic.tsx)
 * — extraída para que o chip de sugestão do Bid Monitor só fique clicável
 * quando o editor de fato vai conseguir abrir (AO-721/AO-722). Sem isso, o
 * clique entra em modo de edição controlado mesmo quando o editor cairia de
 * volta para a view somente-leitura (sem lápis nem Cancelar), travando a
 * célula.
 */
export const useCanEditBudget = (type: 'cpc' | 'cpm') => {
  const { id } = useParams()

  const {
    campaign: {
      item: { data: campaignData }
    },
    industry: {
      budget: {
        minCosts: { data: minCostsData }
      }
    }
  } = useAppSelector(state => state.retailMedia)

  const isReadOnlyView = useCampaignReadOnly()

  const idIsValid = useMemo(
    () => !!campaignData?.id && campaignData.id === id,
    [campaignData?.id, id]
  )

  const isOffsiteTotalBudget = useMemo(
    () =>
      campaignData?.type === 'off_site' &&
      campaignData?.raw?.cost_type === 'total_budget',
    [campaignData]
  )

  return useMemo(
    () =>
      !isPublisher() &&
      !!campaignData &&
      !!minCostsData &&
      idIsValid &&
      !isReadOnly() &&
      !isReadOnlyView &&
      !(isOffsiteTotalBudget && type === 'cpm'),
    [
      campaignData,
      idIsValid,
      minCostsData,
      isOffsiteTotalBudget,
      type,
      isReadOnlyView
    ]
  )
}
